import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ResultsPreview from '@Containers/ResultsPreview';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

import QuickResultsHeading from './Components/QuickResultsHeading';

import './QuickResults.scss';

const spinnerId = 'quick-results-spinner';

function QuickResults(props) {
  const { isLoading, initialize, cancelSubscriptions, searchId, cancelQuery, cancelQueriesInGroup } = props;
  useEffect(() => {
    initialize();

    return () => {
      cancelSubscriptions();
    };
    // eslint-disable-next-line
  }, []);
  return (
    <div className="quick-results e2e-quick-results">
      <QuickResultsHeading {...props} />
      {isLoading && <SimpleSpinner id={spinnerId} />}
      <ResultsPreview searchId={searchId} cancelQuery={cancelQuery} cancelQueriesInGroup={cancelQueriesInGroup} />
    </div>
  );
}

QuickResults.propTypes = {
  initialize: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  cancelSubscriptions: PropTypes.func.isRequired,
  searchId: PropTypes.string,
  cancelQuery: PropTypes.func.isRequired,
  cancelQueriesInGroup: PropTypes.func.isRequired,
  previewResults: PropTypes.array,
};

export default QuickResults;
